import { render, staticRenderFns } from "./FilteredSelect.vue?vue&type=template&id=3dd48920&scoped=true"
import script from "./FilteredSelect.vue?vue&type=script&lang=js"
export * from "./FilteredSelect.vue?vue&type=script&lang=js"
import style0 from "./FilteredSelect.vue?vue&type=style&index=0&id=3dd48920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd48920",
  null
  
)

export default component.exports